module.exports = __webpack_public_path__ + "img/search-header-with-nav-mitsu.08515bf7.png";